export default {"src":"/job-search/_next/static/media/logo-symbol.d142ca75.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};